import React, { useEffect, useState } from "react";
import _ from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector, connect } from "react-redux";
import {
  reduxForm,
  Field,
  initialize,
  //formValueSelector,
  getFormValues,
} from "redux-form";
import { openModal, closeModal, fetchError } from "../../actions";
import {
  Form,
  Container,
  Menu,
  Button,
  Grid,
  Header,
  TabPane,
  Tab,
} from "semantic-ui-react";
import { createBanner, updateBanner, uploadFile } from "../../firebase";
import { TextInput, AdvertiserOptions } from "../utils/form-fields";
import { checkUser } from "../utils/helpers";
import { CancelButton } from "../utils/buttons";
import ValueTileTab from "./tabs/value-tile-tab";
import BackgroundTab from "./tabs/background-tab";
import LogoTab from "./tabs/logo-tab";
import TextTab from "./tabs/text-tab";
import PackshotTab from "./tabs/packshot-tab";
import "./hybrid.css";

let BannerForm = ({
  retailer,
  //template,
  handleSubmit,
  formValues,
  change,
  submitting,
  pristine,
  invalid,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const banner = useSelector((state) => state.banner);
  const advertisers = useSelector((state) => state.advertisers || []);
  const user = useSelector((state) => state.user);
  const template = useSelector((state) => state.template);
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    dispatch(initialize("bannerForm", banner));
    setShowLoading(false);
  }, [dispatch, banner]);

  useEffect(() => {
    const { pathname } = location;
    const arr = pathname.split("/");
    if (
      !arr.find((path) => {
        return path === "new";
      })
    ) {
      if (!checkUser(user, banner.advertiser, retailer)) navigate("/");
    }
  }, [location, user, banner.advertiser, retailer, navigate]);

  const panes = [
    {
      menuItem: "Value tile options",
      render: () => (
        <TabPane>
          <ValueTileTab
            banner={formValues}
            change={change}
            template={template}
          />
        </TabPane>
      ),
    },
    {
      menuItem: "Background Options",
      render: () => (
        <TabPane>
          <BackgroundTab
            banner={formValues}
            handleUpload={handleFileUpload}
            change={change}
            template={template}
          />
        </TabPane>
      ),
    },
    {
      menuItem: "Logo",
      render: () => (
        <TabPane>
          <LogoTab
            banner={formValues}
            handleUpload={handleFileUpload}
            change={change}
            template={template}
          />
        </TabPane>
      ),
    },
    {
      menuItem: "Banner Text",
      render: () => (
        <TabPane>
          <TextTab
            banner={formValues}
            handleUpload={handleFileUpload}
            change={change}
            template={template}
          />
        </TabPane>
      ),
    },
    {
      menuItem: "Packshots",
      render: () => (
        <TabPane>
          <PackshotTab
            banner={formValues}
            handleUpload={handleFileUpload}
            change={change}
          />
        </TabPane>
      ),
    },
  ];

  const getAdvertiser = (advertiser) => {
    return _.find(advertisers, (item) => {
      return item.displayName === advertiser;
    });
  };

  const duplicateName = (field, file) => {
    return _.find(banner.fields, (element, index) => {
      if (index !== field && element.name === file) {
        return element;
      }
    });
  };

  const fileReader = (item) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsDataURL(item);
      reader.name = item.name;
      reader.size = item.size;
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        img.imgName = event.target.name;
        img.size = event.target.size;
        img.onload = (el) => {
          if (el.target)
            return resolve({
              width: el.target.width,
              height: el.target.height,
              size: img.size,
            });
        };
      };
    });
  };

  const checkDimensions = (d, image) => {
    //console.log(image.width, image.height);
    if (d.maxWidth) {
      if (image.width > d.maxWidth) return true;
    }
    if (d.width) {
      if (image.width !== d.width) return true;
    }
    if (d.maxHeight) {
      if (image.height > d.maxHeight) return true;
    }
    if (d.height) {
      if (image.height !== d.height) return true;
    }
    return false;
  };

  const handleFileUpload = async (file, key, title, valid, size) => {
    if (!size) size = "";
    let folder = banner.key || key;
    if (file.type.indexOf("image/") === -1) {
      return dispatch(
        fetchError({
          name: "Upload error",
          error: "Wrong file type. Please upload an image - jpg, gif or png",
        })
      );
    }
    const image = await fileReader(file);
    const error = valid ? checkDimensions(valid, image) : false;
    if (error) {
      return dispatch(
        fetchError({
          name: "Wrong Dimensions!",
          error: `This is image is ${image.width} x ${
            image.height
          }. Please make it ${
            valid.maxWidth
              ? "max-width " + valid.maxWidth + "px"
              : "width " + valid.width + "px"
          }  and ${
            valid.maxHeight
              ? "max-height " + valid.maxHeight + "px"
              : "height " + valid.height + "px"
          }`,
        })
      );
    }
    const dupeField = key.replace("fields.", "");
    const dupe = duplicateName(dupeField, file.name);
    if (dupe) {
      return dispatch(
        fetchError({
          name: "Duplicate file name",
          error: `${dupe.name} already exists. Please rename the file and upload again`,
        })
      );
    }
    uploadFile(file, folder, (data) => {
      dispatch(
        openModal("ProgressModal", {
          size: "tiny",
          progress: data.progress,
          name: file.name,
          title,
          centered: false,
        })
      );
      if (data.progress === 100) {
        change(key, {
          name: data.name,
          path: data.path,
          size: image.size,
          width: image.width,
          height: image.height,
        });
        //window.setTimeout(() => dispatch(closeModal()), 1000);
        dispatch(closeModal());
      }
      if (data.error) {
        dispatch(
          openModal("ErrorModal", {
            size: "tiny",
            centered: false,
            error: {
              name: file.name,
              error: "Image error",
              reason: "File size too large or dimensions are wrong",
            },
          })
        );
      }
    });
  };

  const handleSubmitForm = async (values) => {
    setShowLoading(true);
    let advertiserId = await getAdvertiser(values.advertiser);
    advertiserId = advertiserId.advertiserId;
    let templateId = template.id;
    let bespokeTemplate = false;
    let templateType = template.type;
    let bannerType = banner.bannerType || template.name;
    let currentUser = `${user.displayName} (${user.organisation})`;
    const submitValues = {
      ...values,
      bannerType,
      currentUser: false,
      retailer,
      advertiserId,
      templateId,
      bespokeTemplate,
      templateType,
    };
    submitValues.lastModBy = currentUser;
    //return console.log(submitValues);
    banner.key
      ? updateBanner(submitValues, banner.key, dispatch).then((message) => {
          setShowLoading(false);
        })
      : createBanner(submitValues, dispatch)
          .then((message) => {
            if (message.id) navigate(`/${retailer}/banner/${message.id}`);
            console.log(message);
          })
          .catch((error) => console.log(error));
  };

  return (
    <Form onSubmit={handleSubmit(handleSubmitForm)}>
      <Grid padded className="trade-form">
        <Grid.Row>
          <Grid.Column computer={4} tablet={8} mobile={16}>
            <Header as="h3">Banner info</Header>
            <Field
              name="bannerTitle"
              label="Title"
              type="text"
              component={TextInput}
              placeholder="Add a banner title"
            />
            <Field
              name="adNumber"
              label="Ad number"
              type="text"
              component={TextInput}
              placeholder="Add an ad number"
            />
            <div className="field">
              <div className="field">
                <label htmlFor="advertiser">Advertiser</label>
                <Field
                  name="advertiser"
                  component="select"
                  multiple={false}
                  className="ui selection dropdown"
                >
                  {!user.restrictByAdvertiser && (
                    <option value="">Choose an advertiser</option>
                  )}
                  <AdvertiserOptions advertisers={advertisers} />
                </Field>
              </div>
            </div>
            <Field
              name="bannerURL"
              label="Banner link"
              type="text"
              component={TextInput}
              placeholder="Add a URL link"
            />
          </Grid.Column>
          <Grid.Column computer={12} tablet={16} mobile={16}>
            <Header as="h3">Creative elements</Header>
            <Tab panes={panes} className="hybrid-panes" />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Menu fixed="bottom" size="mini">
        <Container>
          <Menu.Item>
            <Button
              disabled={submitting || pristine || invalid || showLoading}
              positive
              type="submit"
              loading={showLoading}
              size="mini"
            >
              Save
            </Button>
          </Menu.Item>
          <Menu.Item>
            <CancelButton
              id={banner.key}
              location={location}
              retailer={retailer}
              pristine={pristine}
              size="mini"
            />
          </Menu.Item>
        </Container>
      </Menu>
    </Form>
  );
};

const validate = (values) => {
  const errors = {};

  const isUrlValid = (url) => {
    return url.match(
      /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g
    );
  };

  const hasWhiteSpace = (hex) => {
    return hex.match(/\s/g);
  };

  if (!values.bannerTitle) {
    errors.bannerTitle = "Please enter a title";
  }
  if (!values.adNumber || isNaN(Number(values.adNumber))) {
    errors.adNumber = "Please enter a number only";
  }
  if (!values.advertiser) {
    errors.advertiser = "Please select an advertiser";
  }
  if (values.bannerURL) {
    if (!isUrlValid(values.bannerURL)) {
      errors.bannerURL = "Please enter a valid URL";
    }
    if (isUrlValid(values.bannerURL)) {
      if (hasWhiteSpace(values.bannerURL)) {
        errors.bannerURL = "Please remove any spaces";
      }
    }
  }
  if (values.fields) {
    if (values.fields.AddRegularPrice && !values.fields.RegularPrice) {
      if (!errors.fields) errors.fields = {};
      errors.fields = {
        ...errors.fields,
        RegularPrice: "Please enter a Regular Price",
      };
    }
  }

  return errors;
};

BannerForm = reduxForm({
  validate,
  form: "bannerForm",
  //warn,
})(BannerForm);

//const selector = formValueSelector("bannerForm");
BannerForm = connect((state) => {
  const formValues = getFormValues("bannerForm")(state);
  return {
    formValues,
  };
})(BannerForm);

export default BannerForm;
